<div>
  <span class="me-1 d-none d-md-inline-block">{{ 'Scope' | translate }} : </span>
  <span class="sites-clickable"
    (click)="openFiltersDialog(false)"
    [ngClass]="{'previous-perimeters': focusedPerimeter}"
  >{{ 'theme.perimeters-filters-button.sites' | translate:perimetersParams }}</span>

  @if (focusedPerimeter) {
    <span class="focused-perimeter">
      &nbsp;(<b> {{ 'theme.perimeters-filters-button.sites' | translate:focusedPerimetersParams }} </b>
      <fa-icon class="clear-button"
        [icon]="clearIcon"
        [nbTooltip]="clearIconTooltip"
        nbTooltipPlacement="bottom"
        nbTooltipStatus="primary"
        (click)="goBackToPreviousPerimeters()"
      ></fa-icon> )
    </span>
  }
</div>
